import Request from "../request";
const request = new Request();

export class PopupService {
  static create = async (description: any, img: any, startDt: any, endDt: any, isDisplay: any) => {
    const data = new FormData();
    data.append("description", description);
    data.append("img", img);
    data.append("startDt", startDt);
    data.append("endDt", endDt);
    data.append("isDisplay", isDisplay);

    await request.post("admin/popup/create", data);
  };

  static delete = async (pIdx: any) => {
    await request.delete("admin/popup/delete/" + pIdx);
  };

  static update = async (description: any, startDt: any, endDt: any, isDisplay: any, pIdx: any) => {
    const data = { description, startDt, endDt, isDisplay, pIdx };
    await request.patch("admin/popup/update", data);
  };

  static updatewithimg = async (
    description: any,
    img: any,
    startDt: any,
    endDt: any,
    isDisplay: any,
    pIdx: any
  ) => {
    const data = new FormData();
    data.append("description", description);
    data.append("img", img);
    data.append("startDt", startDt);
    data.append("endDt", endDt);
    data.append("isDisplay", isDisplay);
    data.append("pIdx", pIdx);

    await request.patch("admin/popup/update/img", data);
  };

  static list = async () => {
    const res = await request.get("admin/popup/list");
    return res.data;
  };

  static view = async (pIdx: string) => {
    const res = await request.post("admin/popup/view", { pIdx });
    return res.data;
  };

  static img = async (img: string) => {
    const res = await request.get("img/" + { img });
    return res.data;
  };
  static Sales = async () => {
    const result = await request.get(`/admin/stats`);
    return result.data;
  };
}
